<template>
  <NodeEditor
    :node="value"
    @editFinish="$_savingOptionsMixin_onEditFinish"
    @delete="$_savingOptionsMixin_onDelete"
  >
    <component
      class="heading-node__text"
      contenteditable="true"
      ref="heading"
      :is="value.meta.headingLevel || 'h1'"
      @input="onInput"
    />
  </NodeEditor>
</template>

<script>
import NodeEditor from '../NodeEditor/NodeEditor.vue';
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import setCaretToEnd from '../../lib/setCaretToEnd';
import savingOptionsMixin from '../NodeEditor/Mixins/savingOptionsMixin.js';

export default {
  name: 'EditHeadingNode',
  inject: ['editBus'],
  mixins: [savingOptionsMixin],
  props: {
    value: PigeonDocNodeModel,
  },
  components: {
    NodeEditor,
  },
  mounted() {
    this.setText();
  },
  methods: {
    setText() {
      this.$refs['heading'].innerHTML = this.value.content;
      this.$refs['heading'].focus();
      setCaretToEnd(this.$refs['heading']);
    },
    onInput() {
      this.editBus.update({ content: this.$refs['heading'].innerHTML });
    },
  },
  watch: {
    'value.meta.headingLevel'() {
      this.$nextTick(() => this.setText());
    },
  },
};
</script>
